import React from 'react';
import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="border-t border-white/10 px-6 pt-14 pb-8" style={{ backgroundColor: '#100b28' }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-7 h-7 bg-violet-600 rounded-md flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-white">
                  <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
                </svg>
              </div>
              <span className="text-white font-bold">HabitLab</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-4">Build better habits, track your progress, and achieve your goals with HabitLab — the smart habit tracker designed for real results.</p>
            <div className="flex gap-2">
              <span className="flex items-center gap-1.5 px-3 py-1.5 border border-white/20 rounded-md text-white/60 text-xs">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3">
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                </svg>
                SSL Secured
              </span>
              <span className="flex items-center gap-1.5 px-3 py-1.5 border border-white/20 rounded-md text-white/60 text-xs">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3">
                  <rect width="20" height="14" x="2" y="5" rx="2" />
                  <line x1="2" x2="22" y1="10" y2="10" />
                </svg>
                Stripe Payments
              </span>
            </div>
          </div>
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Product</h4>
            <ul className="space-y-2.5">
              <li><Link href="/About" className="text-white/60 hover:text-white text-sm transition-colors">About</Link></li>
              <li><Link href="/Features" className="text-white/60 hover:text-white text-sm transition-colors">Features</Link></li>
              <li><Link href="/Pricing" className="text-white/60 hover:text-white text-sm transition-colors">Pricing</Link></li>
              <li><Link href="/GetStarted" className="text-white/60 hover:text-white text-sm transition-colors">Get Started</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Support</h4>
            <ul className="space-y-2.5">
              <li><Link href="/Faqs" className="text-white/60 hover:text-white text-sm transition-colors">FAQ</Link></li>
              <li><Link href="/Contact" className="text-white/60 hover:text-white text-sm transition-colors">Contact Us</Link></li>
              <li><Link href="/Home" className="text-white/60 hover:text-white text-sm transition-colors">Help Center</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Legal</h4>
            <ul className="space-y-2.5">
              <li><Link href="/PrivacyPolicy" className="text-white/60 hover:text-white text-sm transition-colors">Privacy Policy</Link></li>
              <li><Link href="/TermsOfService" className="text-white/60 hover:text-white text-sm transition-colors">Terms of Service</Link></li>
              <li><Link href="/CookiePolicy" className="text-white/60 hover:text-white text-sm transition-colors">Cookies</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-sm">© 2026 HabitLab. All rights reserved.</p>
          <div className="flex items-center gap-5 text-sm text-white/40">
            <Link href="/PrivacyPolicy" className="hover:text-white transition-colors">Privacy</Link>
            <Link href="/TermsOfService" className="hover:text-white transition-colors">Terms</Link>
            <Link href="/CookiePolicy" className="hover:text-white transition-colors">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
